<template>
  <div style="height:100%;padding: 14px 20px;box-sizing: border-box;">
    <h2 align="center" style="color:green;">调休审核表</h2>
    <el-row>
      <div class="block" width="50%" style="display:inline-block;float:left">
        <data-time @datachange="timechange"></data-time>
        <div style="display:inline-block">
          <el-button
            size="small"
            @click="allpass"
            type="primary"
            v-if="timeFlag=='open' &&  yshangban == '1' "
          >全部通过</el-button>
          <el-button
            size="small"
            @click="restAdd"
            type="success"
            v-if=" timeFlag=='open' && yshangban == '1' "
          >新增一条调休记录</el-button>
        </div>
      </div>
      <div
        style="display:inline-block;float:left;"
        class="titleBumen"
        v-if="timeFlag=='open' && yshangban == '1'"
      >
        <template v-if="base_info">
          <el-select
            v-model="depart_id"
            placeholder="请选择"
            size="small"
            popper-class="select-option"
            @change="gbbumenId"
          >
            <el-option
              v-for="item in base_info.depart_list"
              :key="item.depart_id"
              :label="item.depart_name"
              :value="item.depart_id"
            ></el-option>
          </el-select>
        </template>
      </div>
      <div style="display:inline-block;float:right">
        <el-button @click="exportToExcel" size="small" type="success">导出表格</el-button>
        <el-button size="small" @click="gotohome" type="primary">《《 返回首页</el-button>
      </div>
    </el-row>
    <get-table
      ref="diaoyong"
      :CtableData.sync="tableData"
      @getdata="getstage"
      @bmchange="timechange"
      :CtimeFlag.sync="timeFlag"
      :Cyshangban.sync="yshangban"
      style="height:80%"
    ></get-table>
  </div>
</template>
<script>
import DataTime from "@/base/DataTime";
import GetTable from "./GetTable";
import axios from "axios";
import { showLoading, hideLoading } from "@/lib/loading";
import {
  hourToMin,
  getTaskOptionValue,
  getOptionStrName,
  backHome,
  myGrounpX,
  sfwork,
  exptime
} from "@/lib/until";
export default {
  name: "person",
  components: {
    DataTime,
    GetTable
  },
  data() {
    return {
      nowtime: "",
      personId: "",
      tableData: [],
      base_info: [],
      yshangban: 1,
      timeFlag: ""
    };
  },
  created() {
    this.getuserInfo();
  },
  methods: {
    getstage(opt, jieduan, baseInfo) {
      this.options = opt;
      this.getDatajieduan = jieduan;
      this.base_info = baseInfo;
      //console.log(opt);
      //console.log(baseInfo);
    },
    getuserInfo() {
      var uesrInfo = JSON.parse(localStorage.getItem("uesrInfo"));
      this.depart_id = uesrInfo.depart_ID;
      this.personId = uesrInfo.employee_id;
      this.password = uesrInfo.password;
      //console.log(this.depart_id);
    },
    timechange(time) {
      sfwork(time).then(res => {
        this.yshangban = res;
      });
      exptime(time).then(res => {
        this.timeFlag = res;
      });
      var uesrInfo = JSON.parse(localStorage.getItem("uesrInfo"));
      var department = JSON.parse(localStorage.getItem("department"));
      if (!department && typeof department != "undefined" && department != 0) {
        this.depart_id = uesrInfo.depart_ID;
      } else {
        this.depart_id = department.depart_id;
      }
      //console.log(this.depart_id);
      axios
        .get(IPConfig.IP + "/kpi-management/info/daysoff_report_info.php", {
          params: {
            depart_id: this.depart_id,
            daily_report_date: time,
            //params: { encodeout: "utf-8" }

          }
        })
        .then(data => {
          showLoading();
          //console.log(data.data.errcode);
          if (data.data.errcode == 0) {
            this.tableData = [];
            var searchMsg = data.data;

            var valueList = Object.values(searchMsg.daily_report_list).sort(
              function(a, b) {
                return a.employee_id - b.employee_id;
              }
            );
            this.search(valueList);
          } else {
            this.tableData = [];
          }
        })
        .catch(error => {
          //console.log(error);
          hideLoading();
        });
    },
    search(getDailyMsg) {
      hideLoading();
      var vms;
      for (var i = 0; i < getDailyMsg.length; i++) {
        vms = getDailyMsg[i];
        //console.log(this.options);
        //console.log(vms.task_id);
        vms["value1"] = getTaskOptionValue(vms.task_id, this.options);
        var scopeName = [];
        Object.assign(scopeName, vms["value1"]);
        if (scopeName.length > 0) {
          vms["task_name_str"] = getOptionStrName(
            vms.task_id,
            scopeName,
            this.getDatajieduan
          );
        }

        hourToMin(vms);
        this.tableData.push(vms);
      }
      myGrounpX(this.tableData);
      //console.log(this.tableData);
      // return tableData;
    },
    gotohome() {
      backHome(this);
    },
    exportToExcel() {
      this.$refs.diaoyong.exportToExcel();
    },
    gbbumenId(value) {
      this.$refs.diaoyong.gbbumenId(value);
    },
    allpass() {
      this.$refs.diaoyong.allpass();
    },
    restAdd() {
      this.$refs.diaoyong.restAdd();
    }
  }
};
</script>
<style>
.titleBumen {
  width: 134px !important;
  margin-left: 20px !important;
  color: red !important;
}
</style>




// WEBPACK FOOTER //
// src/views/rest/index.vue